import { render, staticRenderFns } from "./ghiab-alerts.vue?vue&type=template&id=3109c030&"
import script from "./ghiab-alerts.vue?vue&type=script&lang=js&"
export * from "./ghiab-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports